import { Component, OnInit, Input } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { faPlus, faFolderOpen as fafolderopen, faUser } from '@fortawesome/free-solid-svg-icons';
import { faFile, faFolderOpen, faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-openfolder',
  templateUrl: './openfolder.component.html',
  styleUrls: ['./openfolder.component.css']
})
export class OpenfolderComponent implements OnInit {

  @Input() folder_id;

  token: string;

  selectedDir: any;

  parentID: Array<any> = [];
  menu: Array<any> = [];
  navigationArray: Array<any> = [];

  backDir: string;
  // boolean
  show = false;
  enterIf = false;
  disable = false;
  double = false;

  // number
  i = 1;

  // formData
  formData: any;
  uploadForm: FormGroup;

  // Icone
  faPlus = faPlus;
  faFile = faFile;
  faFolderOpen = faFolderOpen;
  faUserCircle = faUserCircle;
  fafolderopen = fafolderopen;
  faUser = faUser;

  folderIdActive: string;

  constructor(
    private globals: GlobalService,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    if (!this.token) {
      this.token = this.globals.getToken();
    }
  }
  canceling() {
    this.activeModal.close('cancel');
  }


}
